<div class="grid-gap-x6">

  <adex-dynamic-form
    (validForm)="validForm$.next($event)"
    (changeForm)="onChangeForm($event)"
    (pressEnter)="onSubmit()"
    [model]="model"
  ></adex-dynamic-form>

  <div class="grid-columns-one-to-two-gap-x2">
    <div class="grid-columns-start-tow">
      <label [formControl]="acceptCheckboxControl" nz-checkbox></label>
      <a class="terms" href="https://adex.com/terms" nz-button nzType="link"
         target="_blank">{{'ACCEPT_TERMS' | translate}}</a>
    </div>
  </div>

  <div class="register-button-container">
    <button
      (click)="onSubmit()"
      [disabled]="(disabledButton$ | async) || loadingFormState"
      [nzLoading]="loadingFormState"
      nz-button
      nzType="primary"
    >
      {{'REGISTER' | translate}}
    </button>
  </div>

  <div class="sign-up-container">
    <div class="grid-columns-start-tow">
      <div>
        <span>{{'ALREADY_HAVE_AN_ACCOUNT' | translate}}?&nbsp;</span>
        <a nz-button nzType="link" routerLink="/auth/login">{{'SIGN_IN' | translate}}</a>
      </div>
    </div>
  </div>
</div>
